import { ReactContentFragmentProps } from './types'
import IsInEditorText from '../shared/IsInEditorText'
import './ReactContentFragment.scss'

const ReactContentFragment = (props: ReactContentFragmentProps) => {
  const { isInEditor } = props
  return (
    <div data-testid={`react-content-fragment`} className={`react-content-fragment`}>
      {IsInEditorText(isInEditor, 'React Content Fragment')}
    </div>
  )
}
export default ReactContentFragment
